import pixel from './pixel';

const SELECTORS = {
  ...pixel.SELECTORS,
};

export default {
  PROPS_TO_SELECTORS: {
    ...pixel.PROPS_TO_SELECTORS,
  },
  SELECTORS,
  ...SELECTORS,
};
